module.exports = __webpack_public_path__ + "f9393751068aa466d8049faa26b86357.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/5.png
// module id = 303
// module chunks = 0